import React from 'react'
import MapSvg from 'images/modules/Manage/i-map.svg?raw'

export { default as MapUrl } from 'images/modules/Manage/i-map.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: MapSvg}} />
)
